import IssueApi from "../data/IssueApi";
import * as ActionTypes from "./ActionTypes";

export function addIssue(issue) {
  //console.log("addIssue");
  return function (dispatch) {
    return IssueApi.saveIssue(issue, (newIssue) => 
      dispatch({
        type: ActionTypes.ADD_ISSUE,
        issue: newIssue,
      })  
    )
  }
}

export function editIssue(issue) {
  //console.log("editIssue");
  return function (dispatch) {
    return IssueApi.editIssue(issue, () =>
      dispatch({
        type: ActionTypes.EDIT_ISSUE,
        issue: issue,
      })
    )
  }
}

export function deleteIssue(issue) {
  //console.log("deleteIssue");
  return function (dispatch) {
    return IssueApi.deleteIssue(issue, () =>
      dispatch({
        type: ActionTypes.DELETE_ISSUE,
        id: issue.id,
      })
    )
  }
}

export function initIssues(searchString) {
  //console.log("initIssues");
  return function (dispatch) {
    return IssueApi.getAllIssue(searchString, initialIssues => 
      dispatch({
        type: ActionTypes.INITIALIZE,
        issues: initialIssues,
      })  
    )
  }
}